import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Modal, Select, TextField, Typography, Tooltip, Divider, Chip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState, useEffect, useRef } from 'react';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { withTranslation } from 'react-i18next';
import { City, Country, State } from 'country-state-city';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { clearCachevalue, getCachevalue, localGetItem, setCachevalue } from '../../../../Utility/Services/CacheProviderService';
import Billling from '../../Billing/CommonBilling/Billling';
import { DateTime } from 'luxon';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import { Demo_Layout_Default_JSON } from '../../../../Utility/Constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';


function NewQuickBilling({ t, is_Nurse, changeNursestate, triggerNotifyCount, VisitDateBalAmount }) {
    const [openAccordion, setOpenAccordion] = useState(false);
    const [layoutFeilds, setlayoutFeilds] = useState(Demo_Layout_Default_JSON)
    const [mandotoryCount, setmandotoryCount] = useState('05')
    const [isDoctorMandatory, setisDoctorMandatory] = useState(false)
    const [quickBillClear, setQuickBillClear] = useState(false)
    const [formState, setFormState] = useState({
        mobile_no: "",
        first_name: "",
        dob: null,
        gender: "",
        age: "",
        title: "",
        middle_name: "",
        surname: "",
        address_1: "",
        address_2: "",
        city: "",
        cityName: City.getCitiesOfState("IN", "TN"),
        state: "",
        district: '',
        country: "",
        pin_code: "",
        employer_id: "",
        employee_id: "",
        email_id: "",
        marital_status: "",
        father_husband_name: "",
        father_husband_age: "",
        mother_name: "",
        mother_age: "",
        occupation: "",
        emergency_contact_person: "",
        emergency_contact_mobile: "",
        relationship: "",
        insurance_company_name: "",
        policy_number: "",
        guardian: "",
        old_referral_no: "",
        blood_group: "",
        caretaker_id: '',
        CorporateList: [],
        InsuranceList: [],
        state_code: "TN",
        country_code: "IN",
        AllCountry: Country.getAllCountries(),
        AllStates: State.getStatesOfCountry("IN"),
        refferedType: "",
        refDoctorData: [],
        refSourceData: [],
        refStaffData: [],
        refferalValue: "",
        refferalDesc: "",
        refTypeData :["Source","Doctor","Staff"],
        rchid:'',
        rchError: false,
    });
    const [SpecializationList, setSpecializationList] = useState([])
    const [DoctorList, setDoctorList] = useState([])
    const [OpthometristList, setOpthometristList] = useState([])
    const [NurseList, setNurseList] = useState([])
    const [DateOpen, setDateOpen] = useState(false)
    const [appointmentDateTime, setappointmentDateTime] = useState(null)
    const [POVList, setPOVList] = useState([])
    const [patientData, setPatientData] = useState({})
    const [SameMobileNumPatients, setSameMobileNumPatients] = useState([])
    const [AppointmentTypeList, setAppointmentTypeList] = useState([])
    const [TagList, setTagList] = useState([])
    const [SlotPopup, setSlotPopup] = useState(false)
    const [selectedDocId, setselectedDocId] = useState(false)
    const[isRefreshing, setIsRefreshing] = useState(false)
    const [SlotList, setSlotList] = useState([])
    const [doctorToken, setDoctorToken] = useState(null)
    const [doctorDetails, setDoctorDetails] = useState({
        selectedSpecId: null,
        selectedSpecName: null,
        selectedDocId: null,
        selectedDoctor: null,
        selectedNurse: null,
        selectedOptometrist: null,
        appointmentDateTime: new Date(),
        selectedSlot: null,
        selectedAppointmentType: null,
        selectedPatientTag: null,
        selectedPurposeOfVist: null,
        filteredDocList: [],
        patientDetails: {},
        selectedAppointTypeId: null,
        RequestedPatientData: null,
        QRPatientData: null,
        followupID: null,
        docId: null,
    })
    const [fullDocList, setfullDocList] = useState([])
    const [fromLab, setFromLab] = useState(false)
    const userData = JSON.parse(localGetItem("loggedInUserInfo"))
    const [disableNameGenderEdit, setDisableNameGenderEdit] = useState(false)
    const [commonPatientData, setCommonPatientData] = useState({})
    const [clearBilling, setClearBilling] = useState(false)
    const [sendDraftData, setSendDraftData] = useState([])
    const [sendPendingOrder, setSendPendingOrder] = useState(null)
    const [fromQuickBill, setFromQuickBill] = useState(false)
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    let enableQms = userData?.is_qms_enabled ? userData?.is_qms_enabled : false
    const [isQmsConfig, setIsQmsConfig] = useState(enableQms)
    const [isDisable, setisDisable] = useState(false)
    const [hasAbha, setHasAbha] = useState(false)
    const isInitialReqDataAssigned = useRef(false);

    useEffect(() => {
        let city_name = localGetItem('city_name')
        let state_name = localGetItem('state_name')
        let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
        let stateList = State.getStatesOfCountry(List?.countryCode)
        let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
        setFormState((prev) => ({
            ...prev,
            city: city_name,
            state_code: List?.isoCode,
            AllStates: stateList,
            cityName: cityList
        }))
        let permissionAccess = userData?.permission_access
        // let access = (permissionAccess?.common?.is_demographics_edit && userData?.is_user) ? true : false
        // setDisableNameGenderEdit(access)
    }, [])

    useEffect(() => {
        getDatas();
        const povList = localGetItem("PurposeOfVisit") === null ? '[]' : localGetItem("PurposeOfVisit");
        setPOVList(JSON.parse(povList));
        const Abha = localGetItem("has_abha_service") === "true" ? true : false
        setHasAbha(Abha)
        if(userData?.module_name === "front_office"){
            getReferralDctorData()
            getRefSourceData()
            getOpthometristList()
        }
    }, []); // Initial fetch

    useEffect(() => {
        let PatientID = getCachevalue("OP_CreateAppointment_PatientId");
        if (PatientID) {
            getPatientDemographics(PatientID);
        }
    }, [getCachevalue("OP_CreateAppointment_PatientId")]);

    const lastAppointmentDateTimeRef = React.useRef(null);
    useEffect(() => {
        if (!doctorDetails.appointmentDateTime) return;
        if (!lastAppointmentDateTimeRef.current || lastAppointmentDateTimeRef.current !== doctorDetails.appointmentDateTime) {
            lastAppointmentDateTimeRef.current = doctorDetails.appointmentDateTime;
            const handler = setTimeout(() => {
                getDoctorDetails();
                getOpthometristList();
            }, 300);
            return () => clearTimeout(handler);
        }
    }, [doctorDetails.appointmentDateTime]);

    let history = useHistory()
    
    useEffect(() => {
        if (getCachevalue('AppRequestPatientData')) {
            let Data = JSON.parse(getCachevalue("AppRequestPatientData"))
            if ((Data?.appointment_date === DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd') || history?.location?.state?.fromFollowUp) && !isInitialReqDataAssigned?.current) {
                if (Data?.patient_id) {
                    getPatientDemographics(Data?.patient_id)
                } else {
                    assignRequestPatientData(Data)
                }
                isInitialReqDataAssigned.current = true;
                setappointmentDateTime(Data?.appointment_date)
                const DocID = DoctorList?.length ? DoctorList.find(item => item.doctor_id === Data?.doctor_id) : null;
                const SpecID = SpecializationList?.length ? SpecializationList.find(item => item.id === DocID?.specialization_id) : null;
                const povData = POVList?.length ? POVList.find(item => item.reason === Data?.message) : null;
                // const appointmentData = AppointmentTypeList?.length ? AppointmentTypeList.find(item => item.appoinment_type === Data?.appoinment_type) : null;

                setDoctorDetails((prev) => ({
                    ...prev,
                    selectedDoctor: DocID,
                    selectedSpecName: SpecID,
                    selectedPurposeOfVist: povData,
                    // selectedAppointmentType: appointmentData,
                    selectedAppointTypeId: Data?.booked_through === "Mobile" ? AppointmentTypeList.find((item) => (item.appoinment_type === "Mobile Appointment" && item.is_active === true)) : AppointmentTypeList.find((item) => (item.appoinment_type === "Telephonic Appointment" && item.is_active === true)),
                    RequestedPatientData: Data
                }))
            }
        }
    }, [getCachevalue('AppRequestPatientData'), DoctorList, SpecializationList, POVList, AppointmentTypeList])

    useEffect(() => {
        if (history?.location?.state?.fromFollowUp) {
            let followId = history?.location?.state?.followupID
            let appointmentDate = history?.location?.state?.AppointDate
            setDoctorDetails((prev) => ({ ...prev, followupID: followId }))
            setappointmentDateTime(appointmentDate)
        }
    }, [history?.location?.state?.fromFollowUp])

    useEffect(() => {
        if (getCachevalue("QRRequestPatientData") && getCachevalue("QRRequestPatientData") !== JSON.stringify(doctorDetails.QRPatientData)) {
            let Data = JSON.parse(getCachevalue("QRRequestPatientData"))
            setDoctorDetails((prev) => ({ ...prev, QRPatientData: Data }))
            setFormState((prev) => ({
                ...prev,
                first_name: Data?.patient_name ? Data?.patient_name : "",
                mobile_no: Data?.mobile_number ? Data?.mobile_number : "",
                address_1: Data?.address ? Data?.address : "",
                email_id: Data?.email ? Data?.email : "",
                gender: Data?.gender ? Data?.gender : "",
                pin_code: Data?.pincode ? Data?.pincode : "",
                referralSource: Data?.referral_source ? Data?.referral_source : "",
                father_husband_name: Data?.father_name ? Data?.father_name : "",
                occupation: Data?.occupation ? Data?.occupation : "",
                district: Data?.district ? Data.district : "",
                guardian: Data?.guardian_name ? Data?.guardian_name : "",
                marital_status: Data?.marital_status ? (Data?.marital_status === 'Unmarried' ? 'Single' : Data?.marital_status) : "",
                aadhar_card_number: Data?.aadhar_number ? Data?.aadhar_number : "",
                selectedFatHusName: Data?.relationship_label ? Data?.relationship_label : '',
                address_1: Data?.address_line_1 ? Data?.address_line_1 : Data?.address ? Data?.address : '',
                address_2: Data?.address_line_2,
                city: Data?.city_name,
                title: Data?.title,
                purposeOfVisit: Data?.purpose_of_visit ? Data?.purpose_of_visit : '',
                blood_group: Data?.blood_group ? Data?.blood_group : '',
                caretaker_id: Data?.caretaker_id ? Data?.caretaker_id : '',
                ccn_number: Data?.ccn_number ? Data?.ccn_number : '',
                age: Data?.age,
                // dob: handleFindApproxDob(Data?.age),
                dob: Data?.dob,
                country_code: Country.getAllCountries().find((item) => item?.name === Data.country)?.isoCode,
                AllStates: State.getStatesOfCountry(Country.getAllCountries().find((item) => item.name === Data.country)?.isoCode),
                state_code: State.getStatesOfCountry(Country.getAllCountries().find((item) => item.name === Data.country)?.isoCode).find((item) => item.name === Data.state_name)?.isoCode,
                patient_id: Data?.patient_id,
                rchid: Data?.rchid ? Data?.rchid : '',

            }))
            if(Data.patient_id == null){
                CheckExistingPatients(Data?.mobile_number)
            }else{
                setFromQuickBill(true)
                setCachevalue(Data.patient_id, "OP_CreateAppointment_PatientId")
                setFormState(prevState => ({ ...prevState, PatientID: Data.patient_id }));
                getPatientDemographics(Data.patient_id);
            }
        }
    }, [getCachevalue("QRRequestPatientData")])

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    useEffect(() => {
    const userData = JSON.parse(localGetItem("loggedInUserInfo"))
    const CustomKey =localGetItem("display_latest_token_number") == "true"? true : false
    if (userData?.token_gen_type === "Doctor" && userData?.module_name === 'front_office' && CustomKey && doctorDetails?.selectedSpecId !==null ) {
    if (!doctorDetails?.docId) return;
    if (!doctorDetails?.appointmentDateTime) return;
    handleDoctorToken();
        }
}, [doctorDetails?.docId]);
    const handleDoctorToken = () => {
        setIsRefreshing(true);

        try {
            var date = new Date(doctorDetails.appointmentDateTime);
            var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
            const startTime = Date.now();
            RestAPIService.getAll(Serviceurls.DOCTOR_TOKEN_NUMBER + `?clinic_id=${localStorage.getItem("clinicId")}&doctor_id=${doctorDetails?.docId}&appointment_date=${appointment_date}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        if (response.data?.token_number == null) {
                            errorMessage("No token available for this doctor");
                        }
                        setDoctorToken(response.data?.token_number ?? "-");
                    }
                })
                .catch((error) => {
                    errorMessage(error?.response?.data?.message || "Error");
                })
                .finally(() => {
                    const timeSpent = Date.now() - startTime;
                    const minDelay = 1000;
                    const remaining = Math.max(0, minDelay - timeSpent);

                    setTimeout(() => {
                        setIsRefreshing(false)
                    }, remaining);
                });

        } catch (e) {
            setIsRefreshing(false);
        }
    }

    const getStaffRefferalData = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_Config).
                then((response) => {
                    if (response.data.status === "success") {
                        setFormState(prevState => ({
                            ...prevState,
                            refStaffData: response.data.data
                        }));
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getOpthometristList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_OPTOMETRIST_LIST + `?only_available=true`).
                then((response) => {
                    if (response.data.status === "success") {
                        setOpthometristList(response.data.data?.length ? response.data.data : [])
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    
    const getReferralDctorData = () => {
    try {
        RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_DOCTOR).
        then((response) => {
            if (response.data.status === "success") {
                setFormState(prevState => ({
                    ...prevState,
                    refDoctorData: response.data.data
                }));
            }
        }).catch((error) => {
            errorMessage(error.message)
        })
    } catch (error) {
        errorMessage(error.message)
    }
    }
    
    const getRefSourceData = () => {
        try {
          RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_SOURCE).
            then((response) => {
              if (response.data.status === "success") {
                setFormState(prevState => ({
                    ...prevState,
                    refSourceData: response.data.data
                }));
              }
            }).catch((error) => {
                errorMessage(error.message)
            })
        } catch (error) {
            errorMessage(error.message)
        }
      }

    const assignRequestPatientData = (Data) => {
        const ageData = typeof Data?.age === "string" ?
            Data?.age?.includes("Y") ? Data?.age?.replace('Y', '')
                : Data?.age : (Data?.age ? Data?.age : null);
          if (Data["referral_source"]) {
               setFormState((prevState) => ({
                ...prevState, refferalValue: Data?.referral_source, refferedType: "Source" }))
            } if (Data["reffered_by"]) {
                setFormState((prevState) => ({
                ...prevState, refferalValue: Data?.reffered_by, refferedType: "Doctor" }))
            } if (Data["referral_staff"]) {
                setFormState((prevState) => ({
                ...prevState, refferalValue: Data?.referral_staff, refferedType: "Staff" }))
            }                
        setFormState((prevState) => ({
            ...prevState,
            first_name: Data?.first_name ? Data?.first_name : "",
            mobile_no: Data?.mobile_number ? Data?.mobile_number : "",
            address_1: Data?.address_line_1 ? Data?.address_line_1 : "",
            address_2: Data?.address_line_2 ? Data?.address_line_2 : "",
            country_code: Country.getAllCountries().find((item) => item.name === Data.country)?.isoCode,
            AllStates: State.getStatesOfCountry(Country.getAllCountries().find((item) => item.name === Data.country)?.isoCode),
            state_code: State.getStatesOfCountry(Country.getAllCountries().find((item) => item.name === Data.country)?.isoCode).find((item) => item.name === Data.state_name)?.isoCode,
            city: Data?.city_name ? Data?.city_name : "",
            pin_code: Data?.pincode ? Data?.pincode : null,
            age: prevState?.age || ageData !== null ? ageData : "",
            dob: (prevState?.dob ? prevState?.dob : (Data?.dob ? Data?.dob : null)) || (ageData !== null ? handleFindApproxDob(ageData) : null),
            gender: prevState?.gender || Data.gender ? Data.gender : "",
            refferalDesc: prevState?.refferalDesc || Data?.referral_description ? Data?.referral_description : "",
        }));
    }

    const getDatas = () => {
        try {
            RestAPIService.getAll(Serviceurls.FODemographicsLayout + `?clinic_id=${localStorage.getItem("clinicId")}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        const Data = response.data.data;
                        setlayoutFeilds(Data[0]?.field_order || Demo_Layout_Default_JSON);
                        const mandatoryCount = Data[0]?.mandatory_field_count;
                        setmandotoryCount(mandatoryCount);
                        const isDoctorMandatory = Data[0]?.field_order?.find((item) => item.label === "Doctor" && item.is_default);
                        setisDoctorMandatory(isDoctorMandatory);
                    } else {
                        errorMessage(response.data.message);
                    }
                }).catch((error) => {
                    errorMessage(error.message);
                });

            RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE)
                .then((response) => {
                    if (response.data.status === "success") {
                        setFormState(prevState => ({
                            ...prevState,
                            CorporateList: response.data.data
                        }));
                    } else {
                        errorMessage(response.data.message);
                    }
                }).catch((error) => {
                    errorMessage(error.message);
                });
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPPATIENTTAG).
                then((response) => {
                    if (response.data.status === "success") {
                        setTagList(response.data.data)
                    }
                    else {
                        errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    errorMessage(error.message)
                })
            RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST)
                .then((response) => {
                    if (response.data.status === "success") {
                        setFormState(prevState => ({
                            ...prevState,
                            InsuranceList: response.data.data
                        }));
                    } else {
                        errorMessage(response.data.message);
                    }
                }).catch((error) => {
                    errorMessage(error.message);
                });
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPAPPOINTMENT)
                .then((response) => {
                    if (response.data.status === "success") {
                        setAppointmentTypeList(response.data.data.filter((item) => item.is_active === true));
                        if (doctorDetails.RequestedPatientData !== null && (Object.keys(doctorDetails.RequestedPatientData)?.length > 0) && !history?.location?.state?.fromFollowUp) {
                            setDoctorDetails((prevState) => ({
                                ...prevState,
                                selectedAppointTypeId: doctorDetails?.RequestedPatientData?.booked_through === "Mobile" ? response.data.data.find((item) => (item.appoinment_type === "Mobile Appointment" && item.is_active === true)) : response.data.data.find((item) => (item.appoinment_type === "Telephonic Appointment" && item.is_active === true))
                            }));
                        } else {
                            setDoctorDetails((prevState) => ({
                                ...prevState,
                                selectedAppointTypeId: response.data.data.find((item) => (item.appoinment_type === "Walk in Appointment" && item.is_active === true ))
                            }));
                        }
                    } else {
                        errorMessage(response.data.message);
                    }
                }).catch((error) => {
                    errorMessage(error.message);
                });
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION + `?clinic_id=${localStorage.getItem("clinicId")}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        setSpecializationList(response.data.data.filter((item) => item.is_active === true));
                    } else {
                        errorMessage(response.data.message);
                    }
                }).catch((error) => {
                    errorMessage(error.message);
                });
            RestAPIService.getAll(Serviceurls.FO_STAFF_LIST)
                .then((response) => {
                    if (response.data.status === "success") {
                        setNurseList(response.data.data)
                    } else {
                        errorMessage(response.data.message);
                    }
                })
            // var date = new Date(appointmentDateTime);
            // var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
            // var appointment_time = DateTime.fromJSDate(date).toFormat('HH:mm');
            // RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?date=${appointment_date}&time=${appointment_time}`)
            //     .then((response) => {
            //         if (response.data.status === "success") {
            //             setfullDocList(JSON.stringify(response.data.data));
            //             setDoctorList(response.data.data.filter((item) => item.specialization_active === true));
            //             if (Object.keys(patientData).length > 0) {
            //                 let DocID = response.data.data.find(item => item.doctor_id === patientData?.doctor_id);
            //                 let SpecID = SpecializationList.find(item => item.id === DocID?.specialization_id);
            //                 setFormState(prevState => ({
            //                     ...prevState,
            //                     selectedDocId: DocID ? DocID : null,
            //                     selectedSpecId: SpecID ? SpecID : null,
            //                 }));
            //                 if (DocID) {
            //                     let filteredLst = response.data.data.filter(item => item.specialization_id === DocID.specialization_id);
            //                     setDoctorList(filteredLst);
            //                 }
            //             }
            //         } else {
            //             errorMessage(response.data.message);
            //         }
            //     }).catch((error) => {
            //         errorMessage(error.message);
            //     });
        } catch (e) {
            errorMessage(e.message);
        }
    };
    const getPincodeToCity = (pincode) => {
        fetch("https://api.postalpincode.in/pincode/" + pincode)
            .then((res) => res.json())
            .then(response => {
                if (response && response[0].Status === "Success") {
                    const data = response[0].PostOffice;
                    if (data && data.length > 0) {
                        const Api_state = (data[0]?.State) === 'Pondicherry' ? 'Puducherry' : (data[0]?.State);
                        setFormState(prevState => ({
                            ...prevState,
                            city: prevState.city || data[0].District,
                            AllStates: prevState.state_code ? prevState.AllStates : State.getStatesOfCountry(Country.getAllCountries().find((item) => (item.name === data[0].Country))?.isoCode),
                            country_code: prevState.country_code || Country.getAllCountries().find((item) => (item.name === data[0].Country))?.isoCode,
                        }));
                        setFormState(prevState => ({
                            ...prevState,
                            state_code: prevState.state_code || prevState.AllStates.find((item) => (item.name === Api_state))?.isoCode,
                            cityName: prevState.city ? prevState.cityName : City.getCitiesOfState(prevState.country_code, prevState.AllStates.find((item) => (item.name === Api_state))?.isoCode)
                        }));
                    }
                }
            })
            .catch(e => {
                errorMessage(e.message)
            });
    };

    const CheckExistingPatients = (mobNo) => {
        try {
            RestAPIService.getAll(Serviceurls.FO_PATIENT_SEARCH + `?search_key=${mobNo}&address_key=&father_husband_key=&clinic_id=${localStorage.getItem("clinicId")}`).
                then((response) => {
                    if (response.data.status === "success") {
                        setSameMobileNumPatients(response.data.data);
                    }
                    else {
                    }
                }).catch((error) => {
                    errorMessage(error.message)
                })
        }
        catch (e) {
            errorMessage(e.message)
        }
    }

    let Mandatory_Array = [];
    let Non_Mandatory_Array = [];
    let listMandatory = [];
    let remainMandatoryList = [];
    const Total_Len = layoutFeilds?.length;
    const SplitCount = +mandotoryCount;

    var Active_Array = layoutFeilds?.filter((item) => {
        return item.is_active === true;
    });

    Mandatory_Array = Active_Array?.slice(0, SplitCount);
    Non_Mandatory_Array = Active_Array?.slice(SplitCount, Total_Len);

    listMandatory = SplitCount > 6 ? Active_Array?.slice(0, 6) : Mandatory_Array;
    remainMandatoryList = Active_Array?.slice(6, SplitCount);

    const handleAgeCalculation = (date) => {
        const age = new Date().getFullYear() - date.getFullYear();
        return age;
    };

    const handleChange = (field, value) => {
        setFormState((prev) => {
            const updatedState = { ...prev, [field]: value };

            // Auto-update gender and marital status based on title
            if (field === 'title') {
                if (value === 'Mr' || value === 'Fr' || value === 'Br') {
                    updatedState.gender = 'm';
                } else if (value === 'Ms' || value === 'Mrs' || value === 'Sr') {
                    updatedState.gender = 'f';
                }
                if (value === 'Mrs') {
                    updatedState.marital_status = 'Married';
                    updatedState.manuallyChanged = true;
                } else if (updatedState.manuallyChanged) {
                    updatedState.marital_status = '';
                }
            }

            return updatedState;
        });
    };
    const handleFindApproxDob = ageEntered => {

        var year = 0;
        var month = 0;
        var days = 0;
        var tempDate;
        year = +(ageEntered)
        if (!year) {
            tempDate = "";
        } else {
            tempDate = DateTime.now().minus({ years: year }).toBSON();
        }

        return tempDate;
    }

    useEffect(() => {
        setFormState((prevState) => ({
            ...prevState,
            state: formState?.AllStates?.find((item) => (item.isoCode === formState?.state_code))?.name,
            country: formState?.AllCountry?.find((item) => (item.isoCode === formState?.country_code))?.name
        }))
    }, [formState?.pin_code, formState?.city, formState?.state_code, formState?.country_code]);

    const renderTextBox = (data, type) => {
        var AbhaDisable = (commonPatientData?.patient_id && hasAbha && commonPatientData?.abha_health_id) ? true : false;
        return (
            <Box
                key={data.field_name}
                sx={{
                    marginTop: '2.5vh',
                    marginLeft: '1vw',
                    width:
                        data.label === 'Age' || data.label === 'Title' ? '7vw' :
                            data.label === 'Gender' ? '10vw' : '12vw',
                }}
            >
                {/* Date of Birth */}
                {data.label === 'Date of Birth' ? (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            disabled={((userData?.module_name === 'Laboratory') && commonPatientData?.patient_id) || AbhaDisable ? true : false}
                            label={`${t(data.label)}${type === 'mandatory' || data.is_default ? '*' : ''}`}
                            value={formState.dob}
                            inputFormat="dd-MM-yyyy"
                            minDate={new Date('1872-01-01')}
                            maxDate={new Date()}
                            onChange={(newDate) => {
                                if (newDate) {
                                    const age = handleAgeCalculation(newDate);
                                    handleChange('dob', newDate);
                                    handleChange('age', age);
                                } else {
                                    handleChange('dob', null);
                                    handleChange('age', '');
                                }
                            }}
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                        />
                    </LocalizationProvider>
                ) :
                    data.label == "Gender" ?
                        (<FormControl size='small' sx={{ width: '10vw' }}>
                            <InputLabel id="gender-select-label">{"Gender *"}</InputLabel>
                            <Select
                                disabled={((userData?.module_name === 'Laboratory') && commonPatientData?.patient_id) || AbhaDisable || disableNameGenderEdit ? true : false}
                                labelId='gender-select-label'
                                size='small'
                                label={t(data.label)}
                                value={formState[data.field_name] || ''}
                                onChange={(e) => handleChange(data.field_name, e.target.value)}
                            >
                                <MenuItem key={1} value={"m"}>{t("Male")}</MenuItem>
                                <MenuItem key={2} value={"f"}>{t("Female")}</MenuItem>
                                <MenuItem key={3} value={"t"}>{t("TransGender")}</MenuItem>
                            </Select>
                        </FormControl>) :
                        data.label == "Marital Status" ?
                            (<FormControl size='small' sx={{ width: '12vw' }}>
                                <InputLabel id="gender-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                                <Select
                                    disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                    sx={{ width: '12vw' }}
                                    labelId='gender-select-label'
                                    size='small'
                                    label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                    value={formState[data.field_name] || ''}
                                    onChange={(e) => handleChange(data.field_name, e.target.value)}
                                >
                                    <MenuItem key={1} value={"Single"}>{t("Single")}</MenuItem>
                                    <MenuItem key={2} value={"Married"}>{t("Married")}</MenuItem>
                                    <MenuItem key={3} value={"Divorced"}>{t("Divorced")}</MenuItem>
                                </Select>
                            </FormControl>) :
                            data.label == "Employee ID No" ?
                                (<TextField
                                    autoComplete="off"
                                    inputProps={{ maxLength: 20 }}
                                    label={(type === 'mandatory' || data.is_default || formState.employer_id) ? (t(data.label) + "*") : t(data.label)}
                                    size="small" value={formState[data.field_name]}
                                    onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                                    onChange={(e) => handleChange(data.field_name, e.target.value.toUpperCase())}
                                    disabled={formState.employer_id === null || formState.employer_id === "" || ((userData?.module_name === 'Laboratory') && commonPatientData?.patient_id)}
                                />) :
                                data.label == "Title" ? (
                                    <FormControl size='small' fullWidth sx={{ textAlign: 'center', height: '1.3vw' }}>
                                        <InputLabel id="title-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                                        <Select
                                            disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                            labelId="title-select-label"
                                            MenuProps={{ style: { maxHeight: 250 } }}
                                            sx={{ fontSize: '0.8vw', }}
                                            size='small'
                                            value={formState[data.field_name] || ''}
                                            label={t(data.label)}
                                            onChange={(e) => handleChange(data.field_name, e.target.value)}
                                        >
                                            <MenuItem value={""}>{"Title"}</MenuItem>
                                            <MenuItem value={"Dr"}>{"Dr"}</MenuItem>
                                            <MenuItem value={"Mr"}>{"Mr"}</MenuItem>
                                            <MenuItem value={"Ms"}>{"Ms"}</MenuItem>
                                            <MenuItem value={"Mrs"}>{"Mrs"}</MenuItem>
                                            <MenuItem value={"Master"}>{"Master"}</MenuItem>
                                            <MenuItem value={"Baby"}>{"Baby"}</MenuItem>
                                            <MenuItem value={"Baby of"}>{"Baby of"}</MenuItem>
                                            <MenuItem value={"Child"}>{"Child"}</MenuItem>
                                            <MenuItem value={"Fr"} >{"Fr"}</MenuItem>
                                            <MenuItem value={"Sr"} >{"Sr"}</MenuItem>
                                            <MenuItem value={"Br"} >{"Br"}</MenuItem>
                                        </Select>
                                    </FormControl>) :
                                    data.label == "Corporate Name" ?
                                        (<FormControl size='small' sx={{ width: '12vw' }}>
                                            <InputLabel id="gender-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                                            <Select
                                                disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                sx={{ width: '12vw' }}
                                                MenuProps={{ style: { maxHeight: 250 } }}
                                                labelId='gender-select-label'
                                                size='small'
                                                label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                                value={formState[data.field_name] || ''}
                                                onChange={(e) => handleChange(data.field_name, e.target.value)}
                                            >
                                                <MenuItem value={""}>{"None"}</MenuItem>
                                                {
                                                    formState.CorporateList?.length > 0 ?
                                                        formState.CorporateList.map((list, index) => (
                                                            <MenuItem key={index} value={list.id}>{list.company_name}</MenuItem>
                                                        )) : null
                                                }
                                            </Select>
                                        </FormControl>) :
                                        data.label === "City" ?
                                            (<Autocomplete
                                                disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                sx={{ width: "12vw" }}
                                                size="small"
                                                options={formState.cityName ? formState.cityName : []}
                                                getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
                                                onChange={(e, value) => {
                                                    handleChange('city', value?.name ? value?.name : '');
                                                }}
                                                clearIcon={false}
                                                value={formState.city}
                                                renderInput={(params) => (
                                                    <TextField
                                                        autoComplete='new-password'
                                                        label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                                        InputProps={{ ...params.InputProps }}
                                                        onChange={(e) => handleChange('city', e.target.value)}
                                                        {...params}
                                                    />)}
                                                onKeyDown={(e) => e.key === "Enter" ? e.preventDefault() : null}
                                            />) :
                                            data.label === 'State' ? (
                                                // State Dropdown
                                                <FormControl size="small" sx={{ width: '12vw' }}>
                                                    <InputLabel>{`${t(data.label)}${type === 'mandatory' || data.is_default ? '*' : ''}`}</InputLabel>
                                                    <Select
                                                        disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                        value={formState.state_code || ''}
                                                        onChange={(e) => {
                                                            handleChange('state_code', e.target.value);
                                                            const cities = City.getCitiesOfState(formState.country_code, e.target.value) || [];
                                                            handleChange('cityName', cities);
                                                            handleChange('city', '');
                                                        }}
                                                    >
                                                        {State.getStatesOfCountry(formState.country_code)?.map((list) => (
                                                            <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            ) : data.label === 'Country' ? (
                                                // Country Dropdown
                                                <FormControl size="small" sx={{ width: '12vw' }}>
                                                    <InputLabel>{`${t(data.label)}${type === 'mandatory' || data.is_default ? '*' : ''}`}</InputLabel>
                                                    <Select
                                                        disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                        value={formState.country_code || ''}
                                                        onChange={(e) => {
                                                            handleChange('country_code', e.target.value);
                                                            handleChange('state_code', '');
                                                            handleChange('city', '');
                                                            handleChange('AllStates', State.getStatesOfCountry(e.target.value));
                                                            handleChange('cityName', []);
                                                        }}
                                                    >
                                                        {Country.getAllCountries()?.map((list) => (
                                                            <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            ) : data.label === 'Father/Spouse Name' ? (
                                                // Father/Spouse Name
                                                <Box display="flex">
                                                    <Select
                                                        disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                        size="small"
                                                        value={formState.selectedFatHusName || ''}
                                                        onChange={(e) => handleChange('selectedFatHusName', e.target.value)}
                                                        sx={{ width: '3.5vw' }}
                                                    >
                                                        <MenuItem value={1}>Father</MenuItem>
                                                        <MenuItem value={2}>Spouse</MenuItem>
                                                    </Select>
                                                    <TextField
                                                        disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                        label={`${t(data.label)}${type === 'mandatory' || data.is_default ? '*' : ''}`}
                                                        value={formState[data.field_name] || ''}
                                                        onChange={(e) => {
                                                            const isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value);
                                                            if (isSpecial || e.target.value === '') {
                                                                handleChange(data.field_name, e.target.value);
                                                            }
                                                        }}
                                                        size="small"
                                                        sx={{ width: '10vw' }}
                                                    />
                                                </Box>
                                                    ) :
                                                        data.label === "RCH ID" ?
                                                            <TextField
                                                                size="small"
                                                                label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                                                inputProps={{
                                                                    maxLength: 13,
                                                                    pattern: "^[0-9-]*$",
                                                                }}
                                                                disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                                value={formState.rchid || ""}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const numericHyphenOnly = /^[0-9-]*$/.test(value);
                                                                    if (!numericHyphenOnly) return;

                                                                    const digitsOnly = value.replace(/-/g, "");
                                                                    const hyphenCount = (value.match(/-/g) || []).length;

                                                                    if (hyphenCount > 1) return;
                                                                    if (digitsOnly.length > 12) return;

                                                                    const rchError = value !== "" && digitsOnly.length !== 12;

                                                                    setFormState((prev) => ({
                                                                        ...prev,         
                                                                        rchid: value,
                                                                        rchError,
                                                                    }));
                                                                }}


                                                                error={formState.rchError}
                                                            // helperText={
                                                            //   state.rchError
                                                            //     ? "Invalid RCH ID. Must have exactly 12 digits and only one hyphen allowed"
                                                            //     : ""
                                                            // }
                                                            // sx={{ width: "12vw", marginTop: "2.5vh", marginLeft: "1vw" }}
                                                            />
                                                            :
                                            
                                            data.label === 'Blood Group' ? (
                                                // Blood Group Dropdown
                                                <Autocomplete
                                                    disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                    options={['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']}
                                                    value={formState[data.field_name] || ''}
                                                    onChange={(event, newValue) => {
                                                        handleChange(data.field_name, newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label={`${t(data.label)}${type === 'mandatory' || data.is_default ? '*' : ''}`} />
                                                    )}
                                                    size="small"
                                                    sx={{ width: '12vw' }}
                                                />
                                            ) :
                                                data.label === "Insurance Company Name" ?
                                                    (<Autocomplete
                                                        disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false}
                                                        // disabled={formState.PatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                                                        sx={{ width: "12vw" }}
                                                        size="small"
                                                        options={formState.InsuranceList}
                                                        getOptionLabel={(option) => (typeof (option) === "string" ? option : option.insurance_name)}
                                                        onChange={(event, value) => {
                                                            handleChange("insurance_company_name", value?.insurance_name ? value?.insurance_name : "");
                                                            handleChange("NewInsurance", false);
                                                        }}
                                                        clearIcon={false}
                                                        value={formState.insurance_company_name}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                label={t("Insurance Company Name")} InputProps={{ ...params.InputProps }}
                                                                onChange={(event) => {
                                                                    handleChange("insurance_company_name", event.target.value);
                                                                    handleChange("NewInsurance", true);
                                                                }}
                                                                {...params}
                                                            />
                                                        )}
                                                    />) :
                                                    data.label === "Mobile no" ? (
                                                        <TextField
                                                            disabled={(userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ? true : false || disableNameGenderEdit}
                                                            label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                                            autoComplete="off"
                                                            size="small"
                                                            onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">{"+91"}</InputAdornment>
                                                            }}
                                                            value={formState[data.field_name]}
                                                            onChange={(e) => {
                                                                const isMobile = /^[0-9\b]+$/.test(e.target.value);
                                                                if (data.label === "Mobile no") {
                                                                    let mobileNum = e.target.value;
                                                                    if ((isMobile && mobileNum.length < 11) || e.target.value === "") {
                                                                        handleChange(data.field_name, e.target.value);
                                                                        if (e.target.value.length === 10) {
                                                                            CheckExistingPatients(e.target.value)
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        // error={formState[data.field_name] !== "" && formState[data.field_name].length !== 10}
                                                        />
                                                    ) : (
                                                        // Default TextField
                                                        <TextField
                                                            disabled={((userData?.module_name === 'Laboratory') && commonPatientData?.patient_id ) || (AbhaDisable && (data.label === "First Name" || data.label === "Middle Name" || data.label === "Surname" || data.label === "Age"))? true : false || disableNameGenderEdit}
                                                            autoComplete="off"
                                                            inputProps={{ maxLength: (data.label === "First Name" || data.label === "Middle Name" || data.label === "Surname" || data.label === "Referred By" || data.label === "Referral Source" || data.label === "Mother's Name" || data.label === "Father/Spouse Name" || data.label === "Emergency Contact Person" || data.label === "Relationship" || data.label === "District") ? 32 : (data.label === "Occupation" || data.label === "'Insurance Company Name'" || data.label === "Insurance No") ? 45 : (data.label === "Email ID") ? 50 : 100 }}
                                                            label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                                            variant="outlined"
                                                            value={formState[data.field_name] || ''}
                                                            onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                                                            onChange={(e) => {
                                                                const isAlpha = /^[A-Za-z]*$/.test(e.target.value);
                                                                const isNum = /^[0-9]*$/.test(e.target.value);
                                                                const isAlphaNum = /^[A-Za-z0-9]*$/.test(e.target.value);
                                                                const isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value);

                                                                if (data.label === "Age" || data.label === "Father/Spouse Age" || data.label === "Mother's Age") {
                                                                    const age = e.target.value;
                                                                    if ((isNum && +(age) <= 150) || e.target.value === "") {
                                                                        handleChange(data.field_name, e.target.value);
                                                                        if (data.label === "Age") {
                                                                            const approxDob = handleFindApproxDob(age);
                                                                            handleChange('dob', approxDob);
                                                                        }
                                                                    } else if (e.target.value.includes("/")) {
                                                                        handleChange('age', "");
                                                                        handleChange('dob', null);
                                                                    }
                                                                } else if (data.label === "First Name" || data.label === "Middle Name" || data.label === "Surname" || data.label === "Emergency Contact Person" || data.label === "Occupation" || data.label === "Relationship" || data.label === "Guardian" || data.label === "District") {
                                                                    if (CommonValidation.alphabetOnly(e.target.value) || e.target.value === "") {
                                                                        handleChange(data.field_name, e.target.value);
                                                                    }
                                                                } else if (data.label === "Father/Spouse Name" || data.label === "Mother's Name") {
                                                                    if (isSpecial || e.target.value === "") {
                                                                        handleChange(data.field_name, e.target.value);
                                                                    }
                                                                } else if (data.label === "Pin Code") {
                                                                    if ((isNum || e.target.value === "") && e.target.value.length <= 6) {
                                                                        handleChange(data.field_name, e.target.value);
                                                                        if (e.target.value.length === 6) {
                                                                            getPincodeToCity(e.target.value);
                                                                        }
                                                                    }
                                                                } else if (data.label === "Emergency Mobile No") {
                                                                    if ((isNum || e.target.value === "") && e.target.value.length <= 10) {
                                                                        handleChange(data.field_name, e.target.value);
                                                                    }
                                                                } else if (data.label === "Insurance No") {
                                                                    if ((isAlphaNum || e.target.value === "")) {
                                                                        handleChange(data.field_name, e.target.value);
                                                                    }
                                                                } else {
                                                                    handleChange(data.field_name, e.target.value);
                                                                }
                                                            }}
                                                            size="small"
                                                        />
                                                    )}
            </Box>
        );
    };
    const renderDropDown = (label, stateKey, Data) => {
        return (
            <Autocomplete
                size="small"
                clearIcon={false}
                disabled={(is_Nurse && label === "Specialization") || isDisable}
                sx={{ width: doctorDetails?.selectedSpecName?.name === "OPHTHALMOLOGY" ? '12.5vw' : "14vw" }}
                value={doctorDetails[stateKey]}
                componentsProps={{
                    popper: {
                        style: {
                            width: label === 'Doctor' ? (isQmsConfig ? "30vw" : "23vw") : label === "Optometrist" ? "23vw" : "14vw"
                        }
                    }
                }}
                options={Array.isArray(Data) ? Data : []}
                getOptionLabel={(item) =>
                    label === "Doctor" ? item.doctor_name :
                        label === "Specialization" ? item.name :
                            label === "Patient Tag" ? item.patient_tag_name :
                                label === "Appointment Type" ? item.appoinment_type :
                                    label === "Nurse" ? item.nurse :
                                       label === "Optometrist" ? item.name :
                                        ""
                }
                renderOption={
                    label === 'Doctor' ? (props, item) => (
                        <Box>
                            {props['data-option-index'] === 0 && (
                                <Box className="eMed_App_Doctor_table_head" sx={{ width: isQmsConfig ? "29vw" : "22vw" }}>
                                    <Typography width={isQmsConfig ? "40%" : "50%"} fontWeight="600" fontSize="0.8vw">Doctor Name</Typography>
                                    <Typography width={isQmsConfig ? "15%" : "25%"} fontWeight="600" fontSize="0.8vw">Total App</Typography>
                                    <Typography width={isQmsConfig ? "15%" : "25%"} fontWeight="600" fontSize="0.8vw">New App</Typography>
                                    {isQmsConfig && (
                                        <Typography width="30%" fontWeight="600" fontSize="0.8vw" paddingLeft="0.5vw">
                                            Availability
                                        </Typography>
                                    )}
                                </Box>
                            )}
                            <Box component="li" className="eMed_App_Doctor_table_data" {...props} sx={{ width: isQmsConfig ? "29vw" : '22vw' }}>
                                <div style={{ width: isQmsConfig ? "40%" : "50%" }}>
                                    {item?.doctor_name.length > 15 ? (
                                        <Tooltip placement="top" title={item?.doctor_name} arrow>
                                            <div>{item?.doctor_name.slice(0, 16) + "..."}</div>
                                        </Tooltip>
                                    ) : (
                                        item?.doctor_name || "-"
                                    )}
                                </div>
                                <Typography width={isQmsConfig ? "15%" : "25%"} textAlign="center" fontWeight="600" fontSize="0.8vw">
                                    {item.total_appointment}
                                </Typography>
                                <Typography width={isQmsConfig ? "15%" : "25%"} textAlign="center" fontWeight="600" fontSize="0.8vw">
                                    {item.new_appointment}
                                </Typography>
                                {isQmsConfig && (
                                    <Box width="30%" sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <Box
                                            className="eMed_Unavailable_point"
                                            sx={{
                                                backgroundColor:
                                                    item.availability === "Available"
                                                        ? "#1E972A"
                                                        : item.availability === "Inpermission"
                                                            ? "#DE7D24"
                                                            : "#B8170D"
                                            }}
                                        />
                                        {item?.reason ? (
                                            <Tooltip placement="top" title={item?.reason} arrow>
                                                <div>{item.availability}</div>
                                            </Tooltip>
                                        ) : (
                                            <Typography>{item.availability}</Typography>
                                        )}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    ) :
                        label === 'Optometrist' ? (props, item) => (
                            <Box>
                                {props["data-option-index"] === 0 ?
                                    <Box className="eMed_App_Doctor_table_head" sx={{ width: "22vw" }}>
                                        <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Optometrist Name</Typography>
                                        <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Total App</Typography>
                                        <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Pending App</Typography>
                                    </Box> : null}
                                <Box component="li" className='eMed_App_Doctor_table_data' {...props} sx={{ width: '22vw' }}>
                                    <div style={{ width: "50%" }}>{item?.name?.length > 15 ? <Tooltip placement="top" title={item?.name} arrow><div>{item?.name.slice(0, 16) + "..."}</div></Tooltip> : item?.name ? item?.name : "-"}</div>
                                    <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.total_appointment_count}</Typography>
                                    <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.pending_appointment_count}</Typography>
                                </Box>
                            </Box>
                        ) : null
                }
                onChange={(event, newValue) => {
                    setDoctorDetails((prevState) => {
                        if (prevState[stateKey] === newValue) return prevState;

                        const updatedState = { ...prevState, [stateKey]: newValue };
                            updatedState["docId"] = newValue?.doctor_id;
                        if (newValue?.doctor_id && label !== "Optometrist") {
                            updatedState["selectedSpecId"] = {
                                ...newValue,
                                name: newValue.specialization_name,
                                id: newValue.specialization_id,
                            };
                        }
                        if(stateKey === "selectedDoctor" && newValue === null){
                            updatedState["selectedSpecId"] = null;
                            updatedState["selectedSpecName"] = null;
                            updatedState["filteredDocList"] = JSON.parse(fullDocList);
                        }

                        if (newValue?.name && label !== "Optometrist") {
                            const filteredLst = JSON.parse(fullDocList)?.filter(
                                (item) => item.specialization_id === newValue.id
                            );
                            updatedState["filteredDocList"] = filteredLst.length > 0 ? filteredLst : [];
                            updatedState["selectedDocId"] = null;
                        }

                        if (newValue === null && label === "Specialization" &&  label !== "Optometrist") {
                            updatedState["filteredDocList"] = Array.isArray(DoctorList) ? DoctorList : [];
                        }

                        if (label === "Doctor" || label === "Specialization") {
                            // checked if label is doctor
                            const selectedSpec = SpecializationList.find(
                                (item) => item?.id === newValue?.specialization_id
                            )?.purpose_of_visit;

                            if (prevState?.selectedPurposeOfVist === null) {
                                const povData = POVList.find(item => item.reason === (selectedSpec || newValue?.purpose_of_visit));
                                updatedState["selectedPurposeOfVist"] = povData;
                            }
                            updatedState["selectedSlot"] = "";
                            updatedState["slotList"] = [];
                        }
                        if (label === "Specialization") {
                            updatedState['selectedOptometrist'] = null
                        }

                        return updatedState;
                    });
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={`${label}${(label === "Doctor" && userData?.token_gen_type === 'Doctor') || label === "Specialization" || label === "Nurse" || label === "Optometrist" ? " *" : ""}`}
                        placeholder={label}
                    />
                )}
            />
        );
    };

    useEffect(() => {
        setDoctorList((prev) => {
            if (
                doctorDetails?.selectedSpecName &&
                doctorDetails?.filteredDocList.length > 0 &&
                prev !== doctorDetails?.filteredDocList
            ) {
                return doctorDetails?.filteredDocList;
            }
            return prev;
        });

        if (doctorDetails?.selectedDoctor) {
            setDoctorDetails((prevState) => ({
                ...prevState,
                selectedSpecName: prevState.selectedSpecName?.id !== doctorDetails?.selectedDoctor?.specialization_id
                    ? {
                        id: doctorDetails?.selectedDoctor?.specialization_id,
                        name: doctorDetails?.selectedDoctor?.specialization_name,
                        is_active: doctorDetails?.selectedDoctor?.specialization_active,
                        name__name: doctorDetails?.selectedDoctor?.specialization_name,
                    }
                    : prevState.selectedSpecName,
            }));
        }
    }, [
        doctorDetails?.filteredDocList,
        doctorDetails?.selectedSpecName?.id,
        doctorDetails?.selectedDoctor?.specialization_id
    ]);

    const getPatientDemographics = (patientId) => {
        try {
            RestAPIService.getAll(Serviceurls.FO_PATIENT_UPDATE + "?patient_id=" + patientId)
                .then(response => {
                    if (response.data.status === "success") {
                        setDoctorDetails((prev) => ({
                            ...prev, patientDetails: response.data.data,
                            selectedDocId: userData?.module_name === "front_office" ? prev?.selectedDocId : response?.data?.data?.doctor_id,
                            selectedDoctor: userData?.module_name === "front_office" ? prev?.selectedDoctor :
                                ((userData?.module_name === 'Radiology' || userData?.module_name === 'Investigation') && response?.data?.data?.doctor_id) ?
                                    {
                                        doctor_name: response?.data?.data?.doctor_name, doctor_id: response?.data?.data?.doctor_id,
                                        specialization_id: response?.data?.data?.specialization_id, specialization_name: response?.data?.data?.specialization_name,
                                    } : null,
                            selectedSpecId: userData?.module_name === "front_office" ? prev?.selectedSpecId : response?.data?.data?.specialization_id,
                            selectedSpecName: userData?.module_name === "front_office" ? prev?.selectedSpecName :
                                ((userData?.module_name === 'Radiology' || userData?.module_name === 'Investigation') && response?.data?.data?.specialization_id) ?
                                    {
                                        id: response?.data?.data?.specialization_id, name: response?.data?.data?.specialization_name,
                                        name__name: response?.data?.data?.specialization_name, is_active: true
                                    } : null,
                        }))
                        if ((userData?.module_name === 'Radiology' || userData?.module_name === 'Investigation') && response?.data?.data?.doctor_id) {
                            setisDisable(true)
                        } else {
                            setisDisable(false)
                        }
                        setCommonPatientData(response.data.data)
                        assignDemographicsData(response.data.data);
                        setFromQuickBill(false)
                    } else {
                        errorMessage(response.data.message);
                    }
                })
                .catch(error => {
                    errorMessage(error.message);
                });
        } catch (e) {
            errorMessage(e.message);
        }
    };

    const getLastVisitDateOutstandingAmount = (PatientID) => {
        try {
          RestAPIService.getAll(Serviceurls.FO_PATIENT_LAST_VISIT_DATE_AND_BALANCE_AMOUNT + "?patient_id=" + PatientID + "&module=OP&branch_id=" + localGetItem("BranchId")).
            then((response) => {
              if (response.data.status === "success") {
                  let Date = response.data?.last_visited_date ? response.data.last_visited_date : ""
                  let Amount = response.data?.total_outstanding ? response.data.total_outstanding : 0
                  let AdvanceBalance = response.data?.advance_balance ? response.data.advance_balance : 0
                  VisitDateBalAmount({"last_visited_date" : Date, "total_outstanding" : Amount, "advance_balance" : AdvanceBalance})
              }
              else {
                errorMessage(response.data.message)
              }
            }).catch((error) => {
              errorMessage(error.message)
            })
        } catch (e) {
          errorMessage(e.message)
        }
      }

    const assignDemographicsData = (data) => {
        try {
            setFormState((prevState) => ({
                ...prevState,
                referredBy: data.reffered_by,
                referralSource: data.referral_source,
                mobile_no: data.mobile_number,
                first_name: data.first_name,
                age: handleAgeCalculation(data.dob !== null ? new Date(data.dob) : new Date(data.approx_dob)),
                dob: data.dob !== null ? new Date(data.dob) : new Date(data.approx_dob),
                gender: data.gender,
                title: data.title,
                middle_name: data.middle_name,
                surname: data.last_name,
                address_1: data.address_line_1,
                address_2: data.address_line_2,
                country_code: Country.getAllCountries().find((item) => item.name === data.country)?.isoCode,
                AllStates: State.getStatesOfCountry(Country.getAllCountries().find((item) => item.name === data.country)?.isoCode),
                state_code: State.getStatesOfCountry(Country.getAllCountries().find((item) => item.name === data.country)?.isoCode).find((item) => item.name === data.state_name)?.isoCode,
                city: data.city_name,
                pin_code: data.pincode,
                employer_id: data.employer_id,
                employee_id: data.id_no,
                email_id: data.email,
                marital_status: data.marital_status,
                father_husband_name: data.father_husband_name,
                father_husband_age: data.father_husband_age || "",
                occupation: data.occupation,
                district: data?.district ? data?.district : "",
                emergency_contact_person: data.caretaker_name,
                emergency_contact_mobile: data.caretaker_mobile,
                relationship: data.caretaker_relationship,
                insurance_company_name: data.insurance_company_name,
                policy_number: data.policy_number,
                guardian: data.guardian,
                mother_name: data.mother_name,
                old_referral_no: data.old_referral_no || "",
                mother_age: data.mother_age,
                company_name: data.company_name || '',
                selectedFatHusName: data.relationship_label || '',
                blood_group: data.blood_group || '',
                patient_id: data?.patient_id,
                caretaker_id: data?.caretaker_id,
                refferalDesc: data?.referral_description || '',
                rchid: data?.rchid || '',
            }));
             if (data["referral_source"]) {
               setFormState((prevState) => ({
                ...prevState, refferalValue: data?.referral_source, refferedType: "Source" }))
            } if (data["reffered_by"]) {
                setFormState((prevState) => ({
                ...prevState, refferalValue: data?.reffered_by, refferedType: "Doctor" }))
            } if (data["referral_staff"]) {
                setFormState((prevState) => ({
                ...prevState, refferalValue: data?.referral_staff, refferedType: "Staff" }))
            }        
            setFormState((prevState) => ({
                ...prevState,
                cityName: City.getCitiesOfState(prevState.country_code, prevState.state_code),
            }));
            if (userData?.module_name === 'front_office') {
                getLastVisitDateOutstandingAmount(data?.patient_id)
            }
        } catch (e) {
            errorMessage(e.message);
        }
    };

    const SameNumberPatientPop = () => {
        return (
            <Modal open={true}>
                <Box className="eMed_MobileNum_Main">
                    <Box component={'div'} className="eMed_MobileNum_Header">
                        <Typography variant='h6'>{"Patient List"}</Typography>
                        <IconButton onClick={() => { setSameMobileNumPatients([]) }} >
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                        </IconButton>
                    </Box>
                    <Box component={'div'} className="eMed_MobileNum_wrapper">
                        {
                            SameMobileNumPatients.length > 0 ?
                                SameMobileNumPatients.map((list) => {
                                    let PatientFullName = `${list.first_name} ${list.last_name}`
                                    list["patient_name"] = PatientFullName
                                    list["patient_mobile_number"] = list.mobile_number
                                    list["patient_photo_url"] = list.photo_url
                                    return (
                                        <Box key={list.patient_id}>
                                            <Box className="eMed_Patient_Num_Search_pop">
                                                <CommonPatientDetails data={list} />
                                                {((list.appointment_date === "" || list.appointment_date !== "") || list.appointment_status === "Cancelled") ? <Tooltip title={"Create Appointment"} arrow>
                                                    <IconButton onClick={() => {
                                                        setFromQuickBill(true)
                                                        setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                                                        setFormState(prevState => ({ ...prevState, PatientID: list.patient_id }));
                                                        setSameMobileNumPatients([]);
                                                        getPatientDemographics(list.patient_id);
                                                    }} disabled ={localGetItem('isNewBilling') === "true" ? false : list?.op_has_current_appointment} position="end">
                                                        <PersonAddAlt1Icon color={(list?.op_has_current_appointment && localGetItem('isNewBilling') === "false") ? 'grey' : 'primary' } />
                                                    </IconButton>
                                                </Tooltip> : <Typography fontSize={'0.8vw'}>{list.appointment_date}</Typography>}
                                            </Box>
                                            <Divider />
                                        </Box>
                                    )
                                }) : null
                        }
                    </Box>
                </Box>
            </Modal>
        )
    }
    const getDoctorDetails = () => {
        try {
            var date = new Date(doctorDetails.appointmentDateTime);
            var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
            var appointment_time = DateTime.fromJSDate(date).toFormat('HH:mm');
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?date=${appointment_date}&time=${appointment_time}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        setfullDocList(JSON.stringify(response.data.data));
                        setDoctorList(response.data.data.filter((item) => item.specialization_active === true));
                        if (Object.keys(patientData).length > 0) {
                            let DocID = response.data.data.find(item => item.doctor_id === patientData?.doctor_id);
                            let SpecID = SpecializationList.find(item => item.id === DocID?.specialization_id);
                            setFormState(prevState => ({
                                ...prevState,
                                selectedDocId: DocID ? DocID : null,
                                selectedSpecId: SpecID ? SpecID : null,
                            }));
                            if (DocID) {
                                let filteredLst = response.data.data.filter(item => item.specialization_id === DocID.specialization_id);
                                setDoctorList(filteredLst);
                            }
                        }
                    } else {
                        errorMessage(response.data.message);
                    }
                }).catch((error) => {
                    errorMessage(error.message);
                });
        } catch (e) {
            errorMessage(e.message);
        }
    };

    const renderDateTimeFilter = () => {
        try {
            let keyDate = localGetItem('no_of_days_allowed_for_future_op_billing') ? +localGetItem('no_of_days_allowed_for_future_op_billing') : 0
            return (
                <Box sx={{ width: '10vw' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            open={DateOpen}
                            onOpen={() => { setDateOpen(true); }}
                            onClose={() => { setDateOpen(false); }}
                            inputFormat='DD-MM-YYYY & hh:mm A'
                            value={doctorDetails.appointmentDateTime}
                            minDate={new Date()}
                            maxDate={new Date(Date.now() + keyDate * 86400000)}
                            onChange={(newDate) => {
                                if (newDate === null) {
                                    setDoctorDetails((prev) => ({
                                        ...prev,
                                        appointmentDateTime: new Date()
                                    }));
                                    // setTimeout(() => getDoctorDetails(), 100);
                                } else {
                                    setDoctorDetails((prev) => ({
                                        ...prev,
                                        appointmentDateTime: newDate?.$d
                                    }));
                                    // setTimeout(() => getDoctorDetails(), 100);
                                }
                            }}
                            renderInput={(params) => <TextField size='small' autoComplete="off"
                                onKeyDown={(e) => e.preventDefault()}
                                onClick={() => { setDateOpen(true); }}
                                {...params}
                                fullWidth
                                variant='outlined'
                                label="Appointment Date & Time *"
                            />}
                        />
                    </LocalizationProvider>
                </Box>
            );
        } catch (e) {
            errorMessage(e.message);
        }
    };
    const convertTo12Hour = (time) => {
        const [hour, minute] = time.split(':').map(Number);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12; // Converts "0" hour to "12"
        return `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
    }
    const OpenAppointmentSlotPopUP = () => {
        return (
            <Box>
                <Modal open={true}>
                    <Box className="eMed_WebCamPop_Main" sx={{ height: "40vh" }}>
                        <Box component={'div'} className="eMed_WebCam_Header">
                            <Typography fontWeight={600} fontSize={'1.1vw'} color={'#000'}>
                                Select Slot
                            </Typography>
                            <Button onClick={() => { setSlotPopup(false) }} >
                                <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                            </Button>
                        </Box>
                        <Box component={'div'} style={{ display: "flex", flexWrap: "wrap", width: "90%", alignItems: "center", margin: "1vw", marginLeft: "2.5vw", height: "25vh", overflow: "scroll" }}>
                            {typeof (SlotList) === 'object' && !Array.isArray(SlotList) ?
                                // When slotList is an object (not array)
                                Object.entries(SlotList).map(([period, timeSlots]) => (
                                    timeSlots.length > 0 && (
                                        <div key={period}>
                                            <Typography fontSize={'1vw'} fontWeight={'bold'} sx={{ marginBottom: '0.5vw' }}>
                                                {`${period} :`}
                                            </Typography>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5vw', marginBottom: '1vw' }}>
                                                {timeSlots.map((item, index) => (
                                                    <Chip className='eMed_chip'
                                                        size="medium"
                                                        label={convertTo12Hour(item)}
                                                        variant={item === doctorDetails?.selectedSlot ? 'contained' : 'outlined'}
                                                        key={index}
                                                        onClick={() => { setDoctorDetails((prevState) => ({ ...prevState, selectedSlot: item || null })) }}
                                                        color={'primary'}
                                                        sx={{ width: "5vw", borderRadius: "0.6vw" }}
                                                        clickable />
                                                ))}
                                            </div>
                                        </div>
                                    )
                                ))
                                :
                                // When slotList is an array or empty
                                SlotList?.length > 0 ? SlotList.map((item, index) => (
                                    <Chip className='eMed_chip'
                                        size="medium"
                                        label={convertTo12Hour(item)}
                                        variant={item === doctorDetails?.selectedSlot ? 'contained' : 'outlined'}
                                        key={index}
                                        onClick={() => { setDoctorDetails((prevState) => ({ ...prevState, selectedSlot: item || null })) }}
                                        color={'primary'}
                                        sx={{ width: "5vw", borderRadius: "0.6vw" }}
                                        clickable />
                                )) :
                                    <Typography sx={{ height: "5vw", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "red" }}>
                                        {"Doctor Schedule not available"}
                                    </Typography>
                            }
                        </Box>
                        <Box component={'div'} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", paddingLeft: "1vw", paddingRight: "3vw" }}>
                            <Button variant='outlined' size='small' id="eMed_Config_btn" style={{ marginRight: "0.5vw" }} onClick={() => { setDoctorDetails((prevState) => ({ ...prevState, selectedSlot: null })) }}>Clear</Button>
                            <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => {
                                let AppointTime = new Date(doctorDetails.appointmentDateTime)
                                if (doctorDetails?.selectedSlot) {
                                    AppointTime.setHours(doctorDetails?.selectedSlot?.split(":")[0]);
                                    AppointTime.setMinutes(doctorDetails?.selectedSlot?.split(":")[1]);
                                }
                                setDoctorDetails((prevState) => ({ ...prevState, appointmentDateTime: (AppointTime && doctorDetails?.selectedSlot) ? AppointTime : doctorDetails?.appointmentDateTime || null }))
                                setSlotPopup(false);
                            }}>Select</Button>
                        </Box>
                    </Box>
                </Modal>
            </Box>
        )
    }

    const getSlotIntervel = () => {
        var AptDateTime = new Date(doctorDetails?.appointmentDateTime);
        var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd');
        try {
            RestAPIService.getAll(Serviceurls.SCHEDULE_TIME_GET + "?date=" + AptDate + "&doctor_id=" + doctorDetails.selectedDoctor?.doctor_id)
                .then((response) => {
                    if (response.data.status === "success") {
                        setSlotList(doctorDetails?.selectedAppointTypeId?.appoinment_type === "Tele Consultation" ?  response.data.data?.tele : (response.data.data?.normal || []),);
                        setSlotPopup(true);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (e) {
            errorMessage(e.message);
        }
    };

    const CreatePatient = (PatientId = null) => {
        try {
            var date = new Date(formState.dob);
            var Dob = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
            const dataForm = new FormData();

            dataForm.append("first_name", formState.first_name || "");
            dataForm.append("last_name", formState.surname || "");
            dataForm.append("middle_name", formState.middle_name || "");
            dataForm.append("father_husband_name", formState.father_husband_name || "");
            dataForm.append("father_husband_age", formState.father_husband_age || "");
            dataForm.append("gender", formState.gender || "");
            dataForm.append("title", formState.title || "");
            dataForm.append("occupation", formState.occupation || "");
            dataForm.append("district", formState.district || "");
            dataForm.append("dob", Dob || "");
            dataForm.append("approx_dob", Dob || "");
            dataForm.append("marital_status", formState.marital_status || "");
            dataForm.append("mobile_number", formState.mobile_no || "");
            dataForm.append("email", formState.email_id || "");
            dataForm.append("address_line_1", formState.address_1 || "");
            dataForm.append("address_line_2", formState.address_2 || "");
            dataForm.append("pincode", formState.pin_code || "");
            dataForm.append("city_name", formState.city || "");
            dataForm.append("state_name", formState.state || "");
            dataForm.append("country", formState.country || "");
            dataForm.append("reffered_by", formState.referredBy || "");
            dataForm.append("referral_source", formState.referralSource || "");
            dataForm.append("id_no", formState.employee_id || "");
            dataForm.append("employer_id", formState.employer_id || "");
            dataForm.append("caretaker_name", formState.emergency_contact_person || "");
            dataForm.append("caretaker_mobile", formState.emergency_contact_mobile || "");
            dataForm.append("caretaker_relationship", formState.relationship || "");
            dataForm.append("insurance_company_name", formState.insurance_company_name || "");
            dataForm.append("policy_number", formState.policy_number || "");
            dataForm.append("guardian", formState.guardian || "");
            dataForm.append("mother_name", formState.mother_name || "");
            dataForm.append("mother_age", formState.mother_age || "");
            dataForm.append("old_referral_no", formState.old_referral_no || "");
            dataForm.append('relationship_label', formState.selectedFatHusName || '');
            dataForm.append('blood_group', formState.blood_group || '');
            dataForm.append('caretaker_id', formState.caretaker_id || '');
            dataForm.append('referral_description', formState.refferalDesc || '');
            dataForm.append('rchid', formState.rchid ? CommonValidation.removeSpace(formState.rchid) : '')
            
            if (formState.refferedType === "Source") {
                dataForm.append("referral_source", !formState.refferalValue  ? "" : CommonValidation.removeSpace(formState.refferalValue))
            } else if (formState.refferedType === "Doctor") {
                dataForm.append("reffered_by", !formState.refferalValue  ? "" : CommonValidation.removeSpace(formState.refferalValue))
            } else if(formState.refferedType === "Staff") {
                dataForm.append("referral_staff", !formState.refferalValue  ? "" : CommonValidation.removeSpace(formState.refferalValue))
            }
            if (formState.rchError) return errorMessage("Invalid RCH ID") 

            if (PatientId !== null) {
                dataForm.append("patient_id", PatientId);
                dataForm.append("clinic_id", localStorage.getItem("clinicId"));
            }

            if (!!formState?.employer_id) {
                if (formState?.employee_id === '') {
                    errorMessage(`Employee Id is Mandatory !`)
                }
            }

            if (!!formState?.insurance_company_name) {
                if (formState?.policy_number === '') {
                    errorMessage('Insurance Number is Mandatory')
                }
            }

            let ApiUrl = PatientId === null ? Serviceurls.FO_PATIENT_CREATE : Serviceurls.FO_PATIENT_UPDATE;

            RestAPIService.create(dataForm, ApiUrl)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        var Data = response.data.data;
                        if (PatientId === null) {
                            if (Data.patient_id) {
                                setFormState((prevState) => ({
                                    ...prevState,
                                    CreatedPatientId: Data.patient_id
                                }));
                                successMessage("Patient Created Successfully");
                            }
                        } else {
                            successMessage("Patient Updated Successfully");
                        }
                        let patient_id = Data?.patient_id ?? PatientId ?? formState.patient_id
                        getPatientDemographics(patient_id)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                });
        } catch (e) {
            errorMessage(e?.message);
        }
    };

    const postLabPatientData = (PatientId = null) => {
        try {
            var date = new Date(formState.dob);
            var Dob = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');

            let data = {
                "first_name": formState.first_name,
                "last_name": formState.surname || '',
                "father_husband_name": formState.father_husband_name,
                "gender": formState.gender || "",
                "title": formState.title || "",
                "occupation": formState.occupation || "",
                "dob": Dob || "",
                "approx_dob": Dob || "",
                "marital_status": formState.marital_status || "",
                "mobile_number": formState.mobile_no || "",
                "mobile_number_2": "",
                "email": formState.email_id || "",
                "address_line_1": formState.address_1 || "",
                "address_line_2": formState.address_2 || "",
                "area_name": "",
                "pincode": formState.pin_code || "",
                "city_name": formState.city || "",
                "state_name": formState.state || "",
                "country": formState.country || "",
                "receive_sms": true,
                "reffered_by": formState.referredBy || "",
                "referral_source": formState.referralSource || "",
                "id_no": formState.employee_id || "",
                "employer_id": formState.employer_id || "",
                'patient_tag': '',
                'rchid': formState.rchid || '',
            }
            if (userData?.laboratory_type === 'Inhouse Laboratory') {
                data['clinic_id'] = +userData?.clinic_id
            }
            RestAPIService.create(data, Serviceurls.LAB_CREATE_PATIENT_DETAILS)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        var Data = response.data.data;
                        if (PatientId === null) {
                            setFromQuickBill(true)
                            if (Data.patient_id) {
                                setFormState((prevState) => ({
                                    ...prevState,
                                    CreatedPatientId: Data.patient_id
                                }));
                                successMessage("Patient Created Successfully");
                                getPatientDemographics(Data.patient_id)
                            }
                        } else {
                            successMessage("Patient Updated Successfully");
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onClearHandler = () => {
        try {
            clearCachevalue("OP_CreateAppointment_PatientId");
            let city_name = localGetItem('city_name')
            let state_name = localGetItem('state_name')
            let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
            let stateList = State.getStatesOfCountry(List?.countryCode)
            let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
            setFormState({
                mobile_no: "",
                first_name: "",
                dob: null,
                gender: "",
                age: "",
                title: "",
                middle_name: "",
                surname: "",
                address_1: "",
                address_2: "",
                city: city_name,
                cityName: cityList,
                AllStates:stateList,
                state_code:List?.isoCode,
                state:List?.isoCode,
                country: "",
                pin_code: "",
                employer_id: "",
                employee_id: "",
                email_id: "",
                marital_status: "",
                father_husband_name: "",
                father_husband_age: "",
                mother_name: "",
                mother_age: "",
                occupation: "",
                district: "",
                emergency_contact_person: "",
                emergency_contact_mobile: "",
                relationship: "",
                insurance_company_name: "",
                policy_number: "",
                guardian: "",
                old_referral_no: "",
                blood_group: "",
                CorporateList: [],
                InsuranceList: [],
                patient_id: null,
                caretaker_id: '',
                rchid:'',
            });
            setDoctorDetails((prev) => ({
                ...prev,
                selectedSpecId: null,
                selectedSpecName: null,
                selectedDocId: null,
                selectedDoctor: null,
                selectedOptometrist: null,
                selectedNurse: null,
                appointmentDateTime: new Date(),
                selectedSlot: null,
                selectedAppointmentType: null,
                selectedPatientTag: null,
                selectedPurposeOfVist: null,
                filteredDocList: [],
                patientDetails: {},
                selectedAppointTypeId: AppointmentTypeList.find((item) => (item.appoinment_type === "Walk in Appointment" && item.is_active === true ))
            }))
            setSameMobileNumPatients([])
            userData?.module_name === 'front_office' && changeNursestate(false)
            setisDisable(false)
            if(userData?.module_name === "front_office"){
               VisitDateBalAmount({})
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const clearPatientDataFromProps = (message) => {
        try {
            if (message) {
                clearCachevalue("OP_CreateAppointment_PatientId");
                setFormState({
                    mobile_no: "",
                    first_name: "",
                    dob: null,
                    gender: "",
                    age: "",
                    title: "",
                    middle_name: "",
                    surname: "",
                    address_1: "",
                    address_2: "",
                    city: "",
                    cityName: City.getCitiesOfState("IN", "TN"),
                    state: "",
                    country: "",
                    pin_code: "",
                    employer_id: "",
                    employee_id: "",
                    email_id: "",
                    marital_status: "",
                    father_husband_name: "",
                    father_husband_age: "",
                    mother_name: "",
                    mother_age: "",
                    occupation: "",
                    emergency_contact_person: "",
                    emergency_contact_mobile: "",
                    relationship: "",
                    insurance_company_name: "",
                    policy_number: "",
                    guardian: "",
                    old_referral_no: "",
                    blood_group: "",
                    refferalDesc: "",
                    refferalValue: "",
                    refferedType: "",
                    CorporateList: [],
                    InsuranceList: [],
                    patient_id: null,
                    caretaker_id: '',
                    rchid:'',
                });
                setCommonPatientData({})
                setDoctorDetails((prev) => ({
                    ...prev,
                    selectedSpecId: null,
                    selectedSpecName: null,
                    selectedDocId: null,
                    selectedDoctor: null,
                    selectedOptometrist: null,
                    selectedNurse: null,
                    appointmentDateTime: new Date(),
                    selectedSlot: null,
                    selectedAppointmentType: null,
                    selectedPatientTag: null,
                    selectedPurposeOfVist: null,
                    filteredDocList: [],
                    patientDetails: {},
                    selectedAppointTypeId: AppointmentTypeList.find((item) => (item.appoinment_type === "Walk in Appointment" && item.is_active === true))
                }))
                setSameMobileNumPatients([])
                setisDisable(false)
                setCommonPatientData({})
                if (userData?.module_name === "front_office") {
                    VisitDateBalAmount({})
                }
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }


    const MandatoryCheck = () => {
        let states = {
            mobile_no: formState?.mobile_no,
            first_name: formState?.first_name,
            age: formState?.age,
            dob: formState?.dob,
            gender: formState?.gender,
            title: formState?.title,
            middle_name: formState?.middle_name,
            surname: formState?.surname,
            address_1: formState?.address_1,
            address_2: formState?.address_2,
            city: formState?.city,
            state: formState?.state,
            country: formState?.country,
            pin_code: formState?.pin_code,
            employer_id: formState?.employer_id,
            employee_id: formState?.employee_id,
            email_id: formState?.email_id,
            marital_status: formState?.marital_status,
            father_husband_name: formState?.father_husband_name,
            father_husband_age: formState?.father_husband_age,
            occupation: formState?.occupation,
            emergency_contact_person: formState?.emergency_contact_person,
            emergency_contact_mobile: formState?.emergency_contact_mobile,
            relationship: formState?.relationship,
            insurance_company_name: formState?.insurance_company_name,
            policy_number: formState?.policy_number,
            guardian: formState?.guardian,
            mother_name: formState?.mother_name,
            mother_age: formState?.mother_age,
            company_name: formState?.company_name,
            relationship_label: formState?.selectedFatHusName,
            blood_group: formState?.blood_group,
            caretaker_id: formState?.caretaker_id,
            rchid: formState?.rchid && !formState?.rchError && formState?.rchid===''
        };
        let MandatoryCount = mandotoryCount
        let flag = true;
        for (let i = 0; i < MandatoryCount; i++) {
            if (CommonValidation.removeSpace(states[layoutFeilds[i].field_name]) === "" || states[layoutFeilds[i].field_name] === null) {
                flag = false
                errorMessage(`${layoutFeilds[i].label} is Mandatory !`)
                break
            } else if (layoutFeilds[i].field_name === 'father_husband_name' && states[layoutFeilds[i].field_name] !== '' && states['relationship_label'] === '') {
                flag = false
                errorMessage('Select Father/Spouse Releationship', 'error')
                break;
            } else {
                flag = true
            }
        }
        if(flag){
            if(formState.refferedType){
                if(!formState.refferalValue){
                    flag = false
                    errorMessage("Kindly select Referral detail")
                }
            }
        }
        return flag
    }

    return (
        <Box component={"div"} className={(userData?.module_name === 'Laboratory') ? '' : "eMed_bill_container"} sx={{ backgroundColor: '#f0f0f0', paddingTop: '0.5vh' }}>
            {(userData?.module_name === 'Laboratory') ?
                <Box component={'div'} borderBottom={'2px solid lightgray'} height={'6dvh'} display={'flex'} alignItems={'center'}>
                    <IconButton
                        onClick={() => {
                            history.push({ pathname: "/MainHome", state: { selectedScreen: "Status", selectedTabID: 0 } })
                            onClearHandler()
                            setCommonPatientData({})
                            setClearBilling(true)
                            clearCachevalue('OP_CreateAppointment_PatientId')
                            setTimeout(() => setClearBilling(false), 100)
                        }}
                    ><ArrowBackIosIcon color='primary' /></IconButton>
                    <Typography fontWeight={600}>Quick Billing</Typography>
                </Box> : null}
            <Box component={'div'} display={'flex'} flexDirection={'column'} sx={{ backgroundColor: 'white', height: 'auto' }}>
                <Accordion expanded={openAccordion} sx={{ zIndex: 3, backgroundColor: 'white', height: '9vh' }} elevation={0}>
                    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} >
                        <AccordionSummary
                            className="emed_qckbill_box1_common"
                            sx={{ paddingTop: -1, paddingBottom: -1, paddingLeft: -1, height: '6vh' }}
                            expandIcon={
                                <IconButton
                                    color="primary"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenAccordion(!openAccordion);
                                    }}
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                            }
                        >
                            {listMandatory.map((item) => renderTextBox(item, 'mandatory'))}
                        </AccordionSummary>
                        <Box>
                            {commonPatientData?.patient_id && userData?.module_name === 'Laboratory' ? null :
                                <Button size='small' variant='contained' sx={{ textTransform: 'capitalize' }}
                                    onClick={() => {
                                        // const mandatoryFields = listMandatory.map(item => item.field_name);
                                        // const emptyFields = mandatoryFields.filter(field => !formState[field]);
                                        // const mandatoryFields2 = remainMandatoryList.map(item => item.field_name);
                                        // const emptyFields2 = mandatoryFields2.filter(field => !formState[field]);

                                        // if (emptyFields.length > 0 && emptyFields2.length > 0) {
                                        //     errorMessage('Please fill all mandatory fields.');
                                        // } else {
                                        if (MandatoryCheck()) {
                                            if (userData?.module_name === 'Laboratory') {
                                                postLabPatientData()
                                            } else {
                                                CreatePatient(commonPatientData?.patient_id);
                                            }
                                        }
                                        // }
                                    }}>{(commonPatientData?.patient_id) ? 'Update' : 'Create'}</Button>}
                            {commonPatientData?.patient_id ?
                                <Button variant='outlined' sx={{ ml: '1rem', height: '4.5vdh', textTransform: 'capitalize' }}
                                    onClick={() => {
                                        onClearHandler()
                                        setCommonPatientData({})
                                        setQuickBillClear(true)
                                    }}
                                >Clear</Button> : null}
                        </Box>
                    </Box>
                    <AccordionDetails sx={{ backgroundColor: 'white' }}>
                        <Box className="eMed_demolayout_left_TextInput" mb={1.3}>
                            {remainMandatoryList.map((item) => renderTextBox(item, 'mandatory'))}
                        </Box>
                        <Box className="emed_qckbill_box1_accordian_detail_box">
                            <Typography className="eMed_Esstial_Fields_title">Essential Information</Typography>
                        </Box>
                        <Box className="eMed_demolayout_left_TextInput">
                            {Non_Mandatory_Array.map((item) => renderTextBox(item, 'non-mandatory'))}
                        {userData?.module_name === "front_office"  &&    
                        <>
                        <FormControl size='small' sx={{ width: '15vw',marginTop: '2.5vh', marginLeft: '1vw' }}>
                            <InputLabel id="referredby-select-label">{"Referred Type"}</InputLabel>
                            <Select
                                labelId="referredby-select-label"
                                MenuProps={{ style: { maxHeight: 250 } }}
                                size='small'
                                value={formState.refferedType}
                                label={"Referred Type"}
                                onChange={(e) => {
                                    setFormState(prevState => ({
                                        ...prevState,
                                        refferedType: e.target.value,
                                        refferalValue: "",
                                    }));
                                }}
                            >
                                {formState.refTypeData?.map((item) => (
                                <MenuItem value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl size='small' sx={{ width: '15vw',marginTop: '2.5vh', marginLeft: '1vw' }}>
                            <InputLabel id="referredby-select-label">{formState.refferedType === "Source" ? "Referred Source":formState.refferedType === "Doctor" ? "Referred Doctor" : formState.refferedType === "Staff" ? "Referred Staff" : "Referral Detail"}</InputLabel>
                            <Select
                                labelId="referredby-select-label"
                                MenuProps={{ style: { maxHeight: 250 } }}
                                size='small'
                                disabled={!formState.refferedType}
                                value={ formState.refferalValue}
                                label={formState.refferedType === "Source" ? "Referred Source" : formState.refferedType === "Doctor" ? "Doctor" : formState.refferedType === "Staff" ? "Referred Staff" : "Referral Detail"}
                                onChange={(e) => {  
                                    setFormState(prevState => ({
                                        ...prevState,
                                        refferalValue: e.target.value,
                                    }));                                        
                                }}
                            >
                                {
                                formState.refferedType === "Doctor" ? formState.refDoctorData?.map((item, index) => (
                                <MenuItem value={item.name}>{item.name}</MenuItem>
                                )) : formState.refferedType === "Source" ? formState.refSourceData?.map((item, index) => (
                                <MenuItem value={item.source_name}>{item.source_name}</MenuItem>
                                )) :formState.refferedType === "Staff" ? formState.refStaffData?.map((item, index) => (
                                <MenuItem value={item?.id}>{item?.name}</MenuItem>
                                )) : null
                                }
                            </Select>
                        </FormControl>
                        <FormControl size='small' sx={{ width: '20vw',marginTop: '2.5vh', marginLeft: '1vw' }}>
                            <TextField
                                multiline
                                label='Referral Description'
                                rows={1}
                                disabled={!formState?.refferedType}
                                value={formState.refferalDesc}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (value?.length < 256) {
                                            setFormState(prevState => ({
                                            ...prevState,
                                            refferalDesc: e.target.value,
                                        }))
                                    } else {
                                        errorMessage('Allowed only 256 characters')
                                    }
                                }}
                                sx={{
                                   "& .MuiInputBase-root": {
                                    height: '5.4dvh', 
                                    },
                                    "& .MuiInputLabel-root": {
                                    top: '-6px', 
                                    }
                                }}
                            />
                        </FormControl>
                        </>
                        }
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Box>
            {userData?.module_name !== 'Laboratory' ? <Box component={'div'} display={'flex'} backgroundColor={'white'}>
                {(userData?.module_name === 'Radiology' || userData?.module_name === 'Investigation') ?
                    <Box className="eMed_quickbill_left_view1" width={'29vw'}>
                        {renderDropDown("Specialization", 'selectedSpecName', SpecializationList)}
                        {
                            is_Nurse ?
                                renderDropDown("Nurse", 'selectedNurse', NurseList)
                                :
                                renderDropDown("Doctor", 'selectedDoctor', DoctorList)
                        }
                    </Box>
                    :
                    <Box display={'flex'}>
                        <Box className="eMed_quickbill_left_view1">
                            {renderDropDown("Specialization", 'selectedSpecName', SpecializationList)}
                            {
                                is_Nurse ?
                                    renderDropDown("Nurse", 'selectedNurse', NurseList)
                                    :
                                    renderDropDown("Doctor", 'selectedDoctor', DoctorList)
                            }
                            {doctorDetails?.selectedSpecName?.name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false" ? renderDropDown("Optometrist", 'selectedOptometrist', OpthometristList) : null}
                            {userData?.has_telemedicine ? renderDropDown("Appointment Type", 'selectedAppointTypeId', AppointmentTypeList) : null}
                            {renderDateTimeFilter()}
                            <Button size='small'
                                disabled={!doctorDetails?.selectedDoctor?.doctor_id || !isQmsConfig}
                                variant='outlined' sx={{ width: "8vw", height: "2.5vw", textTransform: 'capitalize' }} onClick={() => {
                                    getSlotIntervel()
                                }} >{doctorDetails?.selectedSlot ? `Slot : ${convertTo12Hour(doctorDetails?.selectedSlot)}` : "Select Slots"}</Button>
                            {userData?.has_telemedicine ? null :  renderDropDown("Appointment Type", 'selectedAppointTypeId', AppointmentTypeList)}
                        </Box>
                        <Box className="eMed_quickbill_right_view1" >
                            {renderDropDown("Patient Tag", "selectedTagId", TagList)}
                            <Autocomplete
                                inputProps={{ maxLength: 250 }}
                                options={POVList}
                                getOptionLabel={(options) => options?.reason}
                                onChange={(e, value) => {
                                    setDoctorDetails((prevState) => ({ ...prevState, selectedPurposeOfVist: value || null }))
                                }}
                                clearIcon={false}
                                size='small'
                                sx={{ width: '15vw', marginLeft: "1vw", }}
                                value={doctorDetails?.selectedPurposeOfVist}
                                renderInput={(params) => <TextField sx={{ width: "15vw" }}
                                    onChange={(event) => { }}
                                    {...params}
                                    label="Purpose Of Visit *"
                                />}
                            />
                        </Box>
                    </Box>}
            </Box> : <Box component={'div'} display={'flex'} backgroundColor={'white'} height={"5vh"}></Box>}
            <Box component={'div'}>
                <Billling
                    triggerNotifyCount = {triggerNotifyCount}
                    doctorDetails={doctorDetails}
                    fromQuickBill={true}
                    patientData={commonPatientData}
                    clearService={clearBilling}
                    clearAllData={() => {}}
                    quickBillClear={quickBillClear}
                    clearPatientData={clearPatientDataFromProps}
                    doctorToken={doctorToken}
                    handleDoctorToken={handleDoctorToken}
                    isRefreshing={isRefreshing}
                    BillingProps={formState}
                    is_Nurse={is_Nurse}
                />
            </Box>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {SameMobileNumPatients.length > 0 ? SameNumberPatientPop() : null}
            {SlotPopup ? OpenAppointmentSlotPopUP() : null}
        </Box>
    );
}

export default withTranslation()(NewQuickBilling);
